import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import UseCreationSettings from '../../components/Bluecoins/UseCreationSettings';
import { BLE_TABLE_NAME } from '../../components/Bluecoins/constants';
import { PERMISSION_BLUECOINS_USE_CREATION_SETTINGS } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

const usageCreationSettingsSearchSchema = z.object({
  usageMethodStart: z.enum(['move', 'signal']).optional(),
  usageMethodEnd: z.enum(['move', 'signal']).optional(),
  customerIds: z.array(z.coerce.number()).optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/bluecoins/use-creation-settings/$id')({
  validateSearch: usageCreationSettingsSearchSchema,
  beforeLoad: async ({ context, search }) => {
    await requirePermission(
      PERMISSION_BLUECOINS_USE_CREATION_SETTINGS,
      ['update'],
      '/unauthorized',
      context
    );

    if (!search.usageMethodStart || !search.usageMethodEnd || !search.customerIds?.length) {
      throw redirect({ to: '/bluecoins' });
    }

    return {
      ...context,
      documentTitle: { main: 'bluecoin.modal.useCreationSettings.title', suffix: 'menu.bluecoins' },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  if (!search.usageMethodStart || !search.usageMethodEnd || !search.customerIds) {
    return null;
  }

  return (
    <UseCreationSettings
      data={{
        id: Number(id),
        usageMethodStart: search.usageMethodStart,
        usageMethodEnd: search.usageMethodEnd,
        customers: search.customerIds.map((customerId) => ({ id: customerId })),
      }}
      closeCallback={() => navigate({ to: '/bluecoins' })}
      updateTable={() => queryClient.invalidateQueries({ queryKey: [BLE_TABLE_NAME] })}
    />
  );
}
